import { Component, OnInit } from '@angular/core';

@Component({
  template: `
    <button
      style="margin-left: -10px;"
      mat-icon-button
      class="ps-tooltip-button pulse"
      matTooltip="Existem configurações pendentes nesta aba."
      matTooltipPosition="after"
      matTooltipClass="ps-tooltip-content">
      <mat-icon style="line-height: 22px;">
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.168 20.732C16.4147 20.732 20.668 16.4787 20.668 11.232C20.668 5.98526 16.4147 1.73196 11.168 1.73196C5.92126 1.73196 1.66797 5.98526 1.66797 11.232C1.66797 16.4787 5.92126 20.732 11.168 20.732ZM9.70763 6.16706C9.70763 5.61477 10.1553 5.16706 10.7076 5.16706H11.6307C12.183 5.16706 12.6307 5.61477 12.6307 6.16706V11.1138C12.6307 11.6661 12.183 12.1138 11.6307 12.1138H10.7076C10.1553 12.1138 9.70763 11.6661 9.70763 11.1138V6.16706ZM12.9961 15.4699C12.9961 16.4789 12.1782 17.2969 11.1692 17.2969C10.1602 17.2969 9.34225 16.4789 9.34225 15.4699C9.34225 14.4609 10.1602 13.643 11.1692 13.643C12.1782 13.643 12.9961 14.4609 12.9961 15.4699Z" fill="#FFB946"/>
        </svg>
      </mat-icon>
    </button>
  `,
  styles: [``]
})
export class ModificationAlertComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
